import { round } from 'mathjs';
import rotatePolygon from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/rotatePolygon';

function calculatePolygonFromTable(seat, tableType, seatSize) {
    const {
        transformation: { translation: seatTranslation }, [tableType]: {
            transformation: { translation: tableTranslation, rotation: tableRotation },
        },
    } = seat;
    let center = {
        x: round(seatTranslation.x + tableTranslation.x - seatSize, 2),
        y: round(seatTranslation.y + tableTranslation.y, 2),
    };

    let points = [{ x: center.x - seatSize, y: center.y - seatSize }, {
        x: center.x + seatSize,
        y: center.y - seatSize,
    }, { x: center.x + seatSize, y: center.y + seatSize }, { x: center.x - seatSize, y: center.y + seatSize }];

    if (tableRotation !== 0) {
        points = rotatePolygon(points, seat[tableType].compiled.polygon.center, tableRotation);
        [center] = rotatePolygon([center], seat[tableType].compiled.polygon.center, tableRotation);
    }

    return { points, center };
}

export default calculatePolygonFromTable;
